"use client";

import Image from "next/image";
import UkFlag from "@/assets/static/ukFlag.svg?url";

const RegInput = ({ t, register }) => {
  return (
    <div className="inputBox">
      <span>
        <Image
          alt="UK"
          width={54}
          height={54}
          unoptimized
          src={UkFlag}
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw" // How the image scales at different breakpoints
        />
      </span>
      <div className="input-container relative">
        <div className="w-12/12 block relative input-yellow-box h-[48px]">
          <input
            name="reg"
            type="text"
            {...register("reg")}
            id="registration-input"
            className="find-car-input"
            placeholder={t("current_vehicle.registration_placeholder")}
          />
        </div>
      </div>
    </div>
  );
};

export default RegInput;
